import { SET_IS_BASEMAP_VISIBLE } from './types';

export const setIsBasemapVisible = isBasemapVisible => ({
  type: SET_IS_BASEMAP_VISIBLE,
  isBasemapVisible,
});

export default setIsBasemapVisible;
